import { http, DEFAULT_AVATAR } from '@cap/rzmt-core';
import UAParser from 'ua-parser-js';
import { getClientTypeSync, CLIENT_TYPE } from '@cap/utils';

const FROM = getClientTypeSync(navigator.userAgent) || CLIENT_TYPE.unknown;

const parser = new UAParser(navigator.userAgent);
const os = parser.getOS();
const device = os ? os.name : 'unknown';

export const fetchAllOnlineCollege = <T>() => {
  return http.post<T>('tdxsearchservice_allonline');
};

export const fetchChapterProgress = <T>(data: {}, config: { tenant: string; tenantId: number | undefined }) => {
  const { tenant, tenantId } = config;
  return http.post<T>('tdxlearnrecordservice_getchapterprogress', data, {
    params: {
      tenant,
      tenantId,
    },
  });
};

export const fetchCourseDetail = <T>(data: {}, config: { tenant: string; tenantId: number | undefined }) => {
  const { tenant, tenantId } = config;
  return http.post<T>('tdxcourseservice_detail', data, {
    params: {
      tenant,
      tenantId,
    },
  });
};

export const fetchCourseProgress = <T>(data: {}, config: { tenant: string; tenantId: number | undefined }) => {
  const { tenant, tenantId } = config;
  return http.post<T>('tdxlearnrecordservice_getcourseprogress', data, {
    params: {
      tenant,
      tenantId,
    },
  });
};

export const fetchAddFavorite = <T>(data: {}, config: { tenant: string; tenantId: number | undefined }) => {
  const { tenant, tenantId } = config;

  return http.post<T>(
    'tdxfavoriteservice_addfavorite',
    { courseId: +data, device, clientApp: FROM },
    {
      params: {
        tenant,
        tenantId,
      },
    },
  );
};

export const fetchDeleteFavorite = <T>(data: {}, config: { tenant: string; tenantId: number | undefined }) => {
  const { tenant, tenantId } = config;

  return http.post<T>(
    'tdxfavoriteservice_deletefavorite',
    { courseId: +data, device, clientApp: FROM },
    {
      params: {
        tenant,
        tenantId,
      },
    },
  );
};

export const followTeacher = <T>(data: {}, config: { tenant: string; tenantId: number | undefined }) => {
  const { tenant, tenantId } = config;

  return http.post<T>('tdxteacherservice_follow', data, {
    params: {
      tenant,
      tenantId,
    },
  });
};
export const cancelFollowTeacher = <T>(data: {}, config: { tenant: string; tenantId: number | undefined }) => {
  const { tenant, tenantId } = config;

  return http.post<T>('tdxteacherservice_unfollow', data, {
    params: {
      tenant,
      tenantId,
    },
  });
};

export const getReviewStar = <T>(data: {}, config: { tenant: string; tenantId: number | undefined }) => {
  const { tenant, tenantId } = config;

  return http.post<T>('tdxcoursereviewservice_getcoursereviewstar', data, {
    params: {
      tenant,
      tenantId,
    },
  });
};

export const getByPage = <T>(data: {}, config: { tenant: string; tenantId: number | undefined }) => {
  const { tenant, tenantId } = config;

  return http.post<T>('tdxcoursereviewservice_pagegetcoursereview', data, {
    params: {
      tenant,
      tenantId,
    },
  });
};

export const fetchAddLike = <T>(data: {}, config: { tenant: string; tenantId: number | undefined }) => {
  const { tenant, tenantId } = config;

  return http.post<T>(
    'tdxcourselikeservice_addlike',
    { ...data },
    {
      params: {
        tenant,
        tenantId,
      },
    },
  );
};

export const fetchDeleteLike = <T>(data: {}, config: { tenant: string; tenantId: number | undefined }) => {
  const { tenant, tenantId } = config;

  return http.post<T>(
    'tdxcourselikeservice_deletelike',
    { ...data },
    {
      params: {
        tenant,
        tenantId,
      },
    },
  );
};

export const addReview = <T>(data: {}, user: any, config: { tenant: string; tenantId: number | undefined }) => {
  const { tenant, tenantId } = config;
  const { userId, userName, avatarUrl } = user || {};
  return http.post<T>(
    'tdxcoursereviewservice_addreview',
    { ...data, userId, userName, avatarUrl: avatarUrl || DEFAULT_AVATAR },
    {
      params: {
        tenant,
        tenantId,
      },
    },
  );
};

export const deleteReview = <T>(data: {}, config: { tenant: string; tenantId: number | undefined }) => {
  const { tenant, tenantId } = config;
  return http.post<T>(
    'tdxcoursereviewservice_deletereview',
    {
      ...data,
    },
    {
      params: {
        tenant,
        tenantId,
      },
    },
  );
};

export const heartbeat = <T>(data: {}, config: { tenant: string; tenantId: number | undefined }) => {
  const { tenant, tenantId } = config;
  return http.post<T>(
    'tdxlearnrecordservice_heartbeat',
    { ...data },
    {
      params: {
        tenant,
        tenantId,
      },
    },
  );
};
